module.exports = __webpack_public_path__ + "img/xiangduianquan.2483ea1a.png";